<template>
    <div class="com-right-content text-white">
        <div >
            <BlockBox title="品类回收占比" enTitle="Category recovery ratio" height="285">
                <template #content>
                    <div class="custDate">
                        <el-row :gutter="10">
                            <el-col :span="8">
                                <el-date-picker value-format="yyyy-MM-dd" :clearable="false" v-model="plDate"
                                    @change="dataChange($event,'plDate')" size="mini" type="date" placeholder="选择日期">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="8">
                                <el-date-picker value-format="yyyy-MM" :clearable="false" v-model="plMonth"
                                    @change="dataChange($event,'plMonth')" type="month" size="mini" placeholder="选择月">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="8">
                                <el-date-picker value-format="yyyy" :clearable="false" v-model="plYear"
                                    @change="dataChange($event,'plYear')" type="year" size="mini" placeholder="选择年">
                                </el-date-picker>
                            </el-col>
                           
                        </el-row>
                    </div>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div id="chartFwqk" style="height:230px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
            <BlockBox title="总耗损(kg)" enTitle="Total loss" height="112">
                <template #content>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div class="text-center  bigNum" style="height:80px;line-height:80px;color:#e4ff15;"
                            v-if="item.lossWeight">
                            {{item.lossWeight?item.lossWeight:'0'}}
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
            <BlockBox title="今日减碳总量(kg)" enTitle="Total carbon reduction for today" height="112">
                <template #content>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div class="text-center text-green bigNum" style="height:80px;line-height:80px;"
                            v-if="item.dayWeight">
                            {{item.dayWeight?item.dayWeight:'0'}}
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
            <BlockBox title="累积减碳总量(kg)" enTitle="Cumulative Carbon Reduction" height="112">
                <template #content>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div class="text-center  bigNum" style="height:80px;color:#ff94a3;line-height:80px"
                            v-if="item.allWeight">
                           {{item.allWeight?item.allWeight:'0'}}
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
            <BlockBox title="出库统计" enTitle="Outbound Statistics" height="306">
                <template #content>
                    <div class="tabBox">
                        <div class="menuBox flex align-center justify-center">
                            <div class="menuItem " :class="index==zlDataTabIndex?'checked':''"
                                v-for="(item,index) in zlDataTab" :key="index" @click="zlDataTabClck(index)">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <div style="padding:20px 15px 0 15px;box-sizing: border-box">
                        <div id="chartCddjtj" style="height:205px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        

    </div>
</template>

<script>
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox'
    import {
   
        fjRightData,
        fjStatisticsCategory,
        siteDataStatisticsOutSite
    } from "@/api/api";
    export default {
        name: "cityGreenLand",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
                item: {},
                colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],

                // mrhnDay: ['12/05', '12/06', '12/07', '12/08', '12/09'],
                //开始***************
                zrjtzlData: 58879638, //做题总减碳量
                ljjtzlData: 123456789, //做题总减碳量,
                timerRight: null,
                zlDataTab: [{
                    id: "1",
                    name: "全年"
                }, {
                    id: "2",
                    name: "本月"
                }, {
                    id: "3",
                    name: "全天"
                }],
                zlDataTabIndex: 0,
                plDate: "",
                plMonth: "",
                plYear: "",
                siteId: null,
                hstjData:[],
                plList:[]
            }
        },
        mounted() {
             this.siteId=this.$route.query.siteId 
             
            if (this.siteId && this.siteId !== '') {
              this.changeData()
              this.getFjRightData()
              this.getfjStatisticsCategory()
              this.timerRight = setTimeout(() => {
                  this.changeData()
                  this.getFjRightData()
                  this.getfjStatisticsCategory()
              }, 60000);
            }
            else{
                this.$message.error('未获取到siteId');
            }
            

        },
        beforeDestroy() {
            clearTimeout(this.timerRight);
        },
        methods: {
            async changeData() {
                let _self = this
                await siteDataStatisticsOutSite({
                    siteId: _self.siteId,
                    type: _self.zlDataTab[_self.zlDataTabIndex].id,
                }).then(res => {
                     _self.drawCddjtj(res.data.lossList);
                })
            },
            async getFjRightData(){ 
                let _self = this
                await fjRightData({ siteId: _self.siteId,}).then(res=>{
                    _self.item=res.data
                   
                })
            },
            getfjStatisticsCategory() {
                let _self = this
                fjStatisticsCategory({
                    year: _self.plYear,
                    month: _self.plMonth,
                    day: _self.plDate,
                    siteId: _self.siteId
                }).then(res => {
                    _self.plList = res.data.list
                    _self.$nextTick(function() {
                        _self.drawFwqk();
                    });
                })
            },

            drawCddjtj( hstjData) {
                this.chart = this.$echarts.init(document.getElementById("chartCddjtj"));
                let dateList = [];
                let dateValue = [];
                hstjData.forEach(obj => {
                    dateList.push(obj.site_name);
                    dateValue.push(obj.weight);
                })
                let option = {
                    grid: {
                        left: '3%',
                        right: '3.5%',
                        bottom: '3%',
                        top: 20,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',

                        axisTick: {
                            show: false,
                        },
                        data: dateList,
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
                                fontSize: 10 //更改坐标轴文字大小
                            }
                        },
                        splitLine: { //网格线
                            lineStyle: {
                                type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
                                color: ['rgba(45,163,255,0.1)']
                            },
                            show: true //隐藏或显示
                        },
                        axisLine: {
                            show: false, //隐藏或显示
                            lineStyle: {
                                color: '#2da3ff'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
                                fontSize: 10 //更改坐标轴文字大小
                            }
                        },
                        splitLine: { //网格线
                            lineStyle: {
                                type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
                                color: ['rgba(45,163,255,0.1)']
                            },
                            show: true //隐藏或显示
                        },
                        axisLine: {
                            show: false, //隐藏或显示
                            lineStyle: {
                                color: '#ffffff',
                                fontSize: 10
                            }
                        }
                    },
                    series: [{
                        name: '重量/千克',
                        type: 'bar',
                        barWidth: 9,
                        data: dateValue,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: 'white',
                                        fontSize: 12,
                                    },
                                },
                                color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                            offset: 0,
                                            color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
                                        }
                                    ],
                                    global: false, // 缺省为 false
                                }
                            }
                        },

                    }, ]
                };
                // echart图表自适应
                this.chart.setOption(option)
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            },
            drawFwqk() {
                this.chart = this.$echarts.init(document.getElementById("chartFwqk"));
         
                let data = this.plList
                if (this.plList && this.plList.length > 0) {
                    this.plList.forEach(item => {
                        data.push({
                            name: item.name,
                            value: item.weight
                        })
                    })
                }
            
                let option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: 'top',
                        left: 'left',
                        textStyle: {
                            color: '#ffffff' // 设置字体颜色为红色s
                        }
                    },
                    grid: {
                        left: '1%',
                        right: '3.5%',
                        bottom: '3%',
                        top: 20,
                        containLabel: true
                    },
                    series: [{
                        name: '运单数据',
                        type: 'pie',
                        radius: ['30%', '50%'],
                        center: ['50%', '50%'],
                        avoidLabelOverlap: false,
                        padAngle: 30,
                        itemStyle: {
                            borderRadius: 10
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        color:this.colors

                    }]
                };
                // echart图表自适应
                this.chart.setOption(option)
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            },


            formatter(number) {
                const numbers = number.toString().split('').reverse()
                const segs = []

                while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

                return segs.join(',').split('').reverse().join('')
            },
            // 方法开始
            zlDataTabClck(index) {
                this.zlDataTabIndex = index;
                this.changeData();
            },
           dataChange(e, name) {
               this[name] = e
               if (name === "plDate") {
                   this.plMonth = ''
                   this.plYear = ''
               }
               if (name === "plMonth") {
                   this.plDate = ''
                   this.plYear = ''
               }
               if (name === "plYear") {
                   this.plMonth = ''
                   this.plDate = ''
               }
               this.getfjStatisticsCategory()
           
           }


        }
    }
</script>

<style lang="scss">
    .com-right-content {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .wzdjItem {
            width: 100%;
            height: 35px;
            line-height: 21px;
            padding: 11px 0;
            cursor: pointer;
        }

        .wzdjItem:hover {
            color: #006AF6;
        }

        .wzdjItem .leftNum {
            width: 21px;
            height: 21px;
            border-radius: 2px;
            background: #006AF6;
            line-height: 21px;
            text-align: center;
        }

        .wzdjItem .leftNum.one {
            background: -webkit-linear-gradient(top, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
        }

        .wzdjItem .leftNum.two {
            background: -webkit-linear-gradient(top, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
        }

        .shtjBox {
            height: 250px;

            & .swiper {
                height: 250px;
            }
        }
    }


    .hnzbLable {
        margin-top: 10px;
    }

    .hnzbLable .itemLable {
        line-height: 1;
        border: 1px solid;
        color: #2196f3;
        font-size: 12px;
        padding: 5px 7px;
        border-radius: 1px;
    }

    .hnzbLable .itemLable+.itemLable {
        margin-left: 7px;
    }

    .hnzbLable .itemLable.checked {
        background: #006AF6;
        color: #FFFFFF;
        border-color: #006AF6;
    }

    //调整区域****************
    .padding-top-10 {
        padding-top: 10px;
    }

    .videoBox {
        width: 100%;
        height: 205px;
        border-radius: 10rpx;
        overflow: hidden;

        iframe {
            width: 100%;
            height: 240px;
        }
    }

    .text-white {
        color: #FFFFFF;
    }

    .enTitle {
        padding-left: 3px;
        font-size: 13px;
        border-left: 2px solid #FFFFFF;
        margin-left: 7px;
        font-weight: lighter;
    }

    .base-titleBox-flex {
        padding-top: 9px;
        line-height: 1
    }

    .bigNum {
        font-weight: bold;
        line-height: 130px;
        font-size: 48px;
    }

    .text-green {
        color: #15ff15;
    }

    .midTitleBox {
        font-size: 15px;
        font-weight: bold;
        color: #FFFFFF;
        padding-left: 20px;
        box-sizing: border-box;
    }

    .base-font-16 {
        font-size: 16px;
    }

    .text-bold {
        font-weight: bold;
    }

    .custDate {
        padding: 5px 15px 10px 15px;
    }

    .custDate .el-date-editor.el-input,
    .custDate .el-date-editor.el-input__inner {
        width: 140px;

    }

    .el-input__inner {
        background: rgba(8, 69, 120, 0.2);
        border-color: #006AF6;
        color: #00a2d5;
    }

    .el-input__prefix,
    .el-input__suffix {
        color: #00a2d5;
    }
</style>